import { CHANGE_CHECKBOX_FILTER, CHANGE_PRICE_RANGE, CHANGE_RADIO_FILTER, CHANGE_IS_FOR_BOX, CHANGE_IS_FOR_INVENTORY, CHANGE_IS_FOR_SUPER_SPEED, CHANGE_IS_INTERNATIONAL_SHIPPING, setIncludeSearchableOnly } from '../redux/product-listing/product-listing.actions';
export const setIncludesSearchableOnlyMiddleware = ({
  dispatch
}) => next => action => {
  if ([CHANGE_CHECKBOX_FILTER, CHANGE_RADIO_FILTER, CHANGE_PRICE_RANGE, CHANGE_IS_FOR_BOX, CHANGE_IS_FOR_INVENTORY, CHANGE_IS_FOR_SUPER_SPEED, CHANGE_IS_INTERNATIONAL_SHIPPING].includes(action.type)) {
    dispatch(setIncludeSearchableOnly());
  }
  next(action);
};